import React, { useRef, useState } from "react";
import { navigate } from "gatsby";

// import styles from "./styles.module.scss";
import * as styleSheet from "./index.module.scss"

const DentistSelector = ({ dentists }) => {
	const selectRef = useRef();
	const [ error, setError ] = useState(false);

	const goToDentist = () => {
		setError(false);
		if( selectRef.current && selectRef.current.options.selectedIndex ){
			if( selectRef.current.options[selectRef.current.options.selectedIndex].value ){
				navigate(selectRef.current.options[selectRef.current.options.selectedIndex].value);
			} else {
				setError(true);
			}
		} else {
			setError(true);
		}
	}

  	return (
		<div className={styleSheet.DentistSelector}>
	
			<span className={styleSheet.heading}>Quick Select:</span>
			<div className={error ? styleSheet.selectcontainererror : styleSheet.selectcontainer}>
				<select ref={selectRef} aria-label="Go to these dentists:">
					<option value={false}>Choose a dentist</option>
					{ dentists.map( (dentist, index) => {
						return <option key={dentist.id} value={dentist.link} aria-label={`Select ${dentist.title}`}  dangerouslySetInnerHTML={{__html: dentist.title}}></option>
					})}
				</select>	
			</div>
			<button className={styleSheet.go} aria-label="Go to dentist" onClick={(event)=>{ goToDentist();  }}>Go</button>

		</div>
	);
}

export default DentistSelector;
